import { AddIcon } from '@arnold/common';
import { useTranslation } from 'react-i18next';
import { Zone, ZoneButton, ZoneHint } from './editorStyles';
import type { OverviewEditorActions } from './useOverviewEditor';

/** The gap between two rows of the report. Hovering it offers what can be inserted right there. */
export function InsertZone({
  index,
  actions,
  canPlaceAiSummary,
  hasUnplacedQuestions,
  active,
  always,
}: {
  index: number;
  actions: OverviewEditorActions;
  canPlaceAiSummary: boolean;
  hasUnplacedQuestions: boolean;
  /** Highlighted as the current drop target while dragging. */
  active?: boolean;
  /** Keep the buttons visible (empty report). */
  always?: boolean;
}) {
  const { t } = useTranslation('newReport');
  return (
    <Zone active={active} always={always} data-insert-index={index}>
      <div>
        {always && <ZoneHint>{t('definition.addFirstComponent')}</ZoneHint>}
        {canPlaceAiSummary && (
          <ZoneButton type="button" onClick={() => actions.placeAiSummary(index)}>
            <AddIcon /> {t('SurveySummary:title')}
          </ZoneButton>
        )}
        {hasUnplacedQuestions && (
          <ZoneButton type="button" onClick={() => actions.setModal({ kind: 'question', index })}>
            <AddIcon /> {t('definition.question')}
          </ZoneButton>
        )}
        <ZoneButton type="button" onClick={() => actions.addSection(index)}>
          <AddIcon /> {t('definition.section')}
        </ZoneButton>
        <ZoneButton type="button" onClick={() => actions.setModal({ kind: 'library', index })}>
          <AddIcon /> {t('definition.metric')}
        </ZoneButton>
        <ZoneButton type="button" onClick={() => actions.setModal({ kind: 'table', index })}>
          <AddIcon /> {t('definition.tableLabel')}
        </ZoneButton>
      </div>
    </Zone>
  );
}
